import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "JobOfferDetail" })
export default class JobOfferDetail extends Vue {
    public isLoading: boolean = true;
    public jobOfferDetail: any = {};
    public dealer: any = {};
    public dealerPoint: any = {};
    public dealerJobOfferWorkingAreas: any = [];
    public dealerJobOfferOfferTypes: any = [];
    public validationErrors: any = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly offerIdMaster: string;

    @Watch("$route") async onUrlChange() {
        if (this.$route.params.offerIdMaster) {
            await this.getData();
        }
    }

    public async created() {
        await Promise.all([this.getData(), this.getDealerJobOfferFormList()]);
    }

    public async getData() {
        this.isLoading = true;
        try {
            const response = (await Axios.post(this.routes.WorkWithUs_GetJobOfferData, { offerIdMaster: this.offerIdMaster })).data;
            this.dealer = response.dealer;
            this.dealerPoint = response.dealerPoint;
            this.jobOfferDetail = response.dealerJobOffer;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async getDealerJobOfferFormList() {
        const response = (await Axios.post(this.routes.WorkWithUs_GetDealerJobOfferFormList)).data;
        this.dealerJobOfferWorkingAreas = response.dealerJobOfferWorkingAreas;
        this.dealerJobOfferOfferTypes = response.dealerJobOfferOfferTypes;
    }

    public openJobOfferSubmit() {
        this.$router.push({ name: "JobProfileSubmit", params: { offerIdMaster: this.jobOfferDetail.idMaster }, query: { dealerCode: this.jobOfferDetail.dealerCode, dealerPointCode: this.jobOfferDetail.dealerPointCode } }).catch(() => { });
    }

    public navigateBack() {
        this.$router.push({ name: "WorkWithUsLocator" });
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};